(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["itis-cover-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('itis-cover-picker')) return;
    const rootUrl = () => window.Shopify?.routes?.root || '/';
    const number = value => Number.isFinite(Number(value)) ? Number(value) : 0;
    const money = (value, currency) => `${currency} ${(value / 100).toFixed(2)}`;
    let adding = false;

    class ItisCoverPicker extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.selected = false;
        this.withButton = this.querySelector('[data-cover-choice="with"]');
        this.withoutButton = this.querySelector('[data-cover-choice="without"]');
        this.main = this.dataset.context === 'main';
        this.section = this.main ? this.closest('.product-flawless') : null;
        this.form = this.main ? this.closest('form') : null;
        if (this.form) {
          this.form.querySelectorAll('[data-pf-option]').forEach(group => {
            const values = [...group.querySelectorAll('[data-pf-option-value]')];
            if (values.length && values.every(button => ['outbox', 'withoutbox'].includes(button.dataset.value.toLowerCase().replace(/[\s_-]/g, '')))) {
              group.hidden = true;
            }
          });
          this.form.addEventListener('change', () => this.sync(), options);
          this.section.addEventListener('pf:variant-change', () => this.sync(), options);
          this.form.addEventListener('submit', event => {
            if (!this.selected) return;
            event.preventDefault();
            this.submit(false);
          }, options);
        }
        this.withButton.addEventListener('click', () => {
          if (this.withButton.disabled) return;
          this.selected = true;
          this.sync();
        }, options);
        this.withoutButton.addEventListener('click', () => { this.selected = false; this.sync(); }, options);
        this.sync();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      quantity() {
        return this.main ? Math.max(1, Math.floor(number(this.form?.querySelector('[name="quantity"]')?.value) || 1)) : 1;
      }

      available(quantity = this.quantity()) {
        return this.dataset.coverAvailable === 'true' && number(this.dataset.coverStock) >= quantity;
      }

      price() { return this.selected ? number(this.dataset.coverPrice) : 0; }

      sync() {
        const available = this.available();
        if (!available) this.selected = false;
        this.withButton.disabled = !available;
        this.withButton.setAttribute('aria-disabled', String(!available));
        this.withButton.classList.toggle('is-disabled', !available);
        this.withButton.classList.toggle('is-active', this.selected);
        this.withButton.setAttribute('aria-pressed', String(this.selected));
        this.withoutButton.classList.toggle('is-active', !this.selected);
        this.withoutButton.setAttribute('aria-pressed', String(!this.selected));
        if (this.section) {
          const base = number(this.section.dataset.pfPrice);
          const compare = number(this.section.dataset.pfCompare);
          const priceElement = this.section.querySelector('.pf-price');
          const compareElement = this.section.querySelector('.pf-price-compare');
          if (priceElement) priceElement.textContent = money(base + this.price(), this.dataset.currency);
          if (compareElement && compare > base) compareElement.textContent = money(compare + this.price(), this.dataset.currency);
        }
        this.dispatchEvent(new CustomEvent('itis:cover-change', { bubbles: true }));
      }

      error(message) {
        const element = this.querySelector('[data-cover-error]');
        element.textContent = message || '';
        element.hidden = !message;
      }

      append(items, parent) {
        if (!this.selected) return;
        if (!this.available(parent.quantity)) throw new Error(this.dataset.unavailable);
        parent.properties = { ...parent.properties, _box_cover_role: 'eyewear' };
        items.push({ id: number(this.dataset.coverId), quantity: parent.quantity, parent_id: parent.id, properties: { _box_cover_role: 'cover', _box_cover_for: String(parent.id) } });
      }

      async submit(buyNow) {
        if (adding || !this.form.reportValidity()) return;
        this.error('');
        const id = number(this.form.querySelector('[name="id"]')?.value);
        const parent = { id, quantity: this.quantity(), properties: {} };
        if (!id || this.section.dataset.pfAvailable !== 'true') return;
        const buttons = [...this.form.querySelectorAll('[data-pf-add], [data-pf-buy-now]')];
        try {
          for (const [key, value] of new FormData(this.form)) {
            const property = key.match(/^properties\[(.+)\]$/);
            if (property) {
              if (typeof value !== 'string') throw new Error(this.dataset.error);
              parent.properties[property[1]] = value;
            }
            if (key === 'selling_plan' && value) parent.selling_plan = value;
          }
          const items = [parent];
          this.append(items, parent);
          buttons.forEach(button => { button.disabled = true; });
          await window.ItisCovers.add(items, [this]);
          window.location.assign(rootUrl() + (buyNow ? 'checkout' : 'cart'));
        } catch (error) {
          this.error(error.message || this.dataset.error);
          buttons.forEach(button => { button.disabled = this.section.dataset.pfAvailable !== 'true'; });
        }
      }
    }

    window.ItisCovers = {
      async add(items, pickers = []) {
        if (adding) throw new Error(pickers[0]?.dataset.error || 'Please wait.');
        adding = true;
        try {
          const selected = pickers.filter(picker => picker?.selected);
          if (selected.length) {
            const response = await fetch(rootUrl() + 'cart.js', { cache: 'no-store' });
            if (!response.ok) throw new Error(selected[0].dataset.error);
            const cart = await response.json();
            const coverIds = [...new Set(selected.map(picker => number(picker.dataset.coverId)))];
            for (const id of coverIds) {
              const picker = selected.find(item => number(item.dataset.coverId) === id);
              const existing = cart.items.filter(item => item.variant_id === id).reduce((sum, item) => sum + item.quantity, 0);
              const requested = items.filter(item => item.id === id).reduce((sum, item) => sum + item.quantity, 0);
              if (existing + requested > number(picker.dataset.coverStock)) throw new Error(picker.dataset.unavailable);
            }
          }
          const response = await fetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || pickers[0]?.dataset.error || 'Unable to add items.');
          return data;
        } finally { adding = false; }
      }
    };
    customElements.define('itis-cover-picker', ItisCoverPicker);
  })();
  } catch(e) { console.error(e); }
})();

})();
